import { useState, useEffect, use } from 'react';
import { useOutletContext } from 'react-router-dom';
import { EditorTabContent, EditorTabSelectBtn, EditorTabContainer } from './EditorTabs';
import { get_kofi_inventory_cache, get_kofi_commissions_cache, source_kofi_inventory, source_kofi_commissions } from '../../../services/shop_service'
import { CachedItemsEditor, InventoryItemsDetails, CommissionItemsDetails } from './ShopEditorTemp'; 
import './kofi_products_editor.css'
 

const KofiProductsEditor = ({}) => {

    const { user } = useOutletContext();
     
    const [ selectedTab, setSelectedTab ] = useState('inventory')

    const [inventory, setInventory] = useState([])
    const [loadingStatus, setLoadingStatus] = useState(null)
    const [refreshedInventory, setRefreshedInventory] = useState(null)
    const [updateStatus, setUpdateStatus] = useState(null)

    const [commissions, setCommissions] = useState([])
    const [commissionsLoadingStatus, setCommissionsLoadingStatus] = useState(null)
    const [refreshedCommissions, setRefreshedCommissions ] = useState(null) 
    const [commissionsUpdateStatus, setCommissionsUpdateStatus] = useState(null)
     
    const handle_change_tab = ( tab_id ) => setSelectedTab(tab_id) 
 
    const handle_update = async () => { 
        setUpdateStatus('in_progress')
        source_kofi_inventory((inventory) => {
            console.log('completed sourcing inventory data ')
            setRefreshedInventory(inventory) 
            setUpdateStatus('completed')
        },
        (err) => {
            console.log('Error while sourcing inventory data: ' + err)  
            setUpdateStatus('failed')
        }) 
    }

    const handle_commissions_update = async () => { 
        setCommissionsUpdateStatus('in_progress')
        source_kofi_commissions(
            (data) => {
                console.log('completed sourcing commissions data ')
                setRefreshedCommissions(data) 
                setCommissionsUpdateStatus('completed')
            }, 
            (err) => {
                console.log('error sourcing commissions data ' + err) 
                setCommissionsUpdateStatus('failed')
            }
        ) 
    }

    useEffect(() => {
        setLoadingStatus('in_progress') 
        get_kofi_inventory_cache(
            (cache_data) => {
                console.log('succesfully fetched kofi shop cache')
                setInventory(cache_data)
                setLoadingStatus('completed')
            },
            (err) => {
                console.log('error fetching kofi shop cache: ' + err)
                setLoadingStatus('failed') 
            }
        )

        setCommissionsLoadingStatus('in_progress')
        get_kofi_commissions_cache(
            (cache_data) => {
                console.log('succesfully fetched kofi commissions cache')
                setCommissions(cache_data)
                setCommissionsLoadingStatus('completed') 
            }, 
            (err) => {
                console.log('error fetching kofi commissions cache: ' + err)
                setCommissionsLoadingStatus('failed') 
            }
        )  
    }, [])
 

    return (
        <div className="kofi-shop main-content">
            <h1>Edit Kofi Products</h1>
            <div className="kofi-products-editor-tabs"> 
                <div className="editor-tabs-navbar"> 
                    <EditorTabSelectBtn 
                        text={'Inventory'} 
                        tab_id={'inventory'} 
                        selected_id={selectedTab} 
                        select={handle_change_tab} />
                    <EditorTabSelectBtn 
                        text={'Commissions'} 
                        tab_id={'commissions'}
                        selected_id={selectedTab}  
                        select={handle_change_tab} /> 
                </div>

                <EditorTabContainer>
                    <EditorTabContent 
                            tab_id={"inventory"}
                            selected_id={selectedTab}>
                        <CachedItemsEditor 
                            subject={'inventory'}
                            cacheCopy={inventory} 
                            updatedItems={refreshedInventory}
                            loadStatus={loadingStatus} 
                            updateStatus={updateStatus} 
                            handleUpdate={handle_update} 
                            CacheDataView={InventoryItemsDetails}  /> 
                    </EditorTabContent>
                    <EditorTabContent 
                            tab_id={"commissions"}
                            selected_id={selectedTab}> 
                        <CachedItemsEditor
                            subject={'commissions'}
                            cacheCopy={commissions} 
                            updatedItems={refreshedCommissions}
                            loadStatus={commissionsLoadingStatus} 
                            updateStatus={commissionsUpdateStatus} 
                            handleUpdate={handle_commissions_update}
                            CacheDataView={CommissionItemsDetails} />  
                    </EditorTabContent>
                </EditorTabContainer> 
            </div> 
        </div>
    )
}

export default KofiProductsEditor;